// extracted by mini-css-extract-plugin
export var csatScore = "_ms-5";
export var header = "_ms-1";
export var panelWrapper = "_ms-2";
export var postPreview = "_ms-3";
export var rightContent = "_ms-0";
export var wrappingText = "_ms-4";